import { Box, Heading } from 'wix-style-react';
import * as React from 'react';
import { translate } from 'react-i18next';
export var InvoiceNumberLabel = translate()(function (_a) {
    var invoiceNumber = _a.invoiceNumber, customInvoiceNumberLabel = _a.customInvoiceNumberLabel, t = _a.t;
    var invoiceNumberLabel = customInvoiceNumberLabel
        ? t('invoice-view:invoice_view.custom-invoice-number-label', {
            customInvoiceNumberLabel: customInvoiceNumberLabel,
            number: invoiceNumber,
        })
        : t('invoice-view:invoice_view.invoice_number', {
            number: invoiceNumber,
        });
    return (React.createElement(Box, { whiteSpace: "nowrap", paddingBottom: "10px" },
        React.createElement(Heading, { appearance: 'H3', dataHook: "invoice-number" }, invoiceNumberLabel)));
});
//# sourceMappingURL=InvoiceNumberLabel.js.map